<div class="p-px-24 d-flex flex-column">
  <div class="d-flex justify-content-end pb-px-12 cursor-pointer">
    <svg-icon
      (click)="onDialogClose()"
      src="/assets/icons/close-modal-primary.svg"
      class="cursor-pointer"
    ></svg-icon>
  </div>
  <mat-tab-group
    mat-stretch-tabs="{{ false }}"
    mat-align-tabs="start"
    color="primary"

  >
    <mat-tab label="Détails">
      <ng-container *ngIf="!loading">
        <div class="py-px-24 d-flex flex-column">
          <app-user
            [text]="candidat?.fullname"
            [imageSrc]="candidat?.photo"
          ></app-user>
          <app-text-separator
            innerClass="my-px-24"
            text="Details"
          ></app-text-separator>
          <div class="d-flex">
            <div class="d-flex flex-column gap-4 flex-grow-1">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Adresse mail </div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.mailadress || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Fonction</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.typePosteDto?.name || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Domaine d’activité </div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.typeSecteurDto?.name || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Années d’expérience</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.yearsOfExperiances || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Clé et numéro de sécurité sociale</div>
                <div class="fs-16 fw-4 text-neutral-dark">
                    {{candidat?.socialKey || 'N/A'}} - {{ candidat?.numsocialsecurity || 'N/A'}}
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Nationalité</div>
                <div class="fs-16 fw-4 text-neutral-dark">
                    {{candidat?.nationality || 'N/A'}}
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">
                  Département de résidence
                </div>
                <div class="fs-16 fw-4 text-neutral-dark">
                  {{ candidat?.adresseCandidatDto?.additionalAdress }}
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Situation de handicap</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.ishandicap ?  candidat?.handicapsituation : 'Non'}}</div>
              </div>

            </div>
            <div class="d-flex flex-column gap-4 flex-grow-1">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Téléphone</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.numtel || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Age</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.age || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Inscrit(e) sur la plateforme depuis</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.inscriptionYears || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Numéro SIRET</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ candidat?.numsiret || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Date de l’obtention de diplôme</div>
                <div class="fs-16 fw-4 text-neutral-dark">
                  {{candidat?.graduationYear || 'N/A'}}
                </div>
              </div>
            </div>
          </div>
          <app-text-separator
            innerClass="my-px-24"
            text="Évaluations et missions"
          ></app-text-separator>
          <div class="d-flex gap-2 justify-content-between">
            <div class="d-flex flex-column col-6">
              <div class="d-flex gap-2 align-items-center">
                <div class="fw-4 fs-24 text-neutral-dark">{{ candidat.rating }}</div>
                <app-rating
                  [rating]="candidat.rating"
                  [readOnly]="true"
                  [width]="14"
                  [height]="14"
                ></app-rating>
              </div>
              <div class="text-neutral-dark fs-14 mt-1">
                / {{ candidat?.ratingCount || 0 }} Évaluation(s)
              </div>
              <div class="fs-13 fw-3 text-neutral-dark">Évaluation moyenne</div>
            </div>
            <div class="d-flex flex-column col-6">
              <div class="fw-4 fs-24 text-neutral-dark">{{ candidat?.terminatedMission || 0 }}</div>
              <div class="fs-13 fw-3 text-neutral-dark">
                Total des missions effectuées.
              </div>
            </div>
            <!--            <div class="d-flex flex-column col-4">-->
            <!--              <div class="fw-4 fs-24 text-neutral-dark">{{ candidat?.collaborationCount || 0 }}</div>-->
            <!--              <div class="fs-13 fw-3 text-neutral-dark">-->
            <!--                Collaborations précédentes avec votre établissement.-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="loading">
        <app-loader></app-loader>
      </ng-container>
    </mat-tab>

    <mat-tab label="Documents">
      <app-documents-candidat
        [candidate]="candidat">
      </app-documents-candidat>
    </mat-tab>
    
  <mat-tab label="Planning">
    <div *ngIf="!calenderLoader">
      <app-calendar
        [actionBtn]="true"
        [data]="randomData"
        [events]="events"
        [user]="user"
        [isCandidat]="true"
        [disponibilityDays]="disponibilityDays"
      ></app-calendar>
    </div>
  </mat-tab>

  </mat-tab-group>

</div>
